export const BUSINESS = {
  name: "Tailor Inc.",
  phone: "816-427-1286",
  email: "",
  city: "Blue Springs, Missouri",
  area: "Greater Kansas City",
  year: "2008",
  instagram: "https://instagram.com/tailorinckc",
  instagramHandle: "@tailorinckc",
};

export const PRICING = [
  { group: "Jackets & Coats", items: [["Jacket side take-in", "$35–$75"], ["Sleeve taper", "$35–$65"], ["Sleeve shortening", "$35–$85"]] },
  { group: "Trousers & Jeans", items: [["Plain trouser hem", "$18–$30"], ["Cuffed hem", "$25–$40"], ["Waist adjustment", "$25–$55"], ["Trouser taper", "$30–$65"], ["Seat adjustment", "$30–$65"], ["Crotch adjustment", "$30–$70"], ["Jeans standard hem", "$18–$30"], ["Jeans original hem", "$25–$45"], ["Jeans waist adjustment", "$30–$65"]] },
  { group: "Shirts", items: [["Side take-in", "$25–$45"], ["Shirt taper", "$35–$60"], ["Sleeve taper", "$25–$45"], ["Sleeve shortening", "$25–$45"]] },
  { group: "Dresses & Formalwear", items: [["Strap adjustment", "$20–$45"], ["Dress side take-in", "$30–$75"], ["Simple dress hem", "$30–$65"], ["Multilayer / lined hem", "$55–$125+"], ["Bridal / complex formalwear", "By consultation"]] },
];

export const DISCLOSURE =
  "These are starting estimates for commonly requested alterations—not a complete list of services or prices. Tailor Inc. performs many additional alterations not shown here. Final pricing depends on garment construction, fabric, complexity, and inspection and is confirmed before work begins. Travel, rush, after-hours, and other applicable fees are quoted separately.";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
